import { createSelector } from 'reselect';
import { RootState } from '@store/index';

const getPending = (state: RootState) => state.settings.pending;

const getSettings = (state: RootState) => state.settings.data;

export const getSettingsSelector = createSelector(getSettings, (settings) => settings);

export const getPendingSelector = createSelector(getPending, (pending) => pending);

export const getUpdatedSubscriptionOptions = createSelector(
  getSettings,
  (settings) => settings?.subscriptionOptions,
);

export const getCachedSubscriptionIdSelector = createSelector(
  getSettings,
  (settings) => settings?.defaultSubscription,
);

export const getCachedProductIdSelector = createSelector(
  getSettings,
  (settings) => settings?.defaultProductShopifyId,
);
